import { useUser } from 'context/user/User';
import { canOpenRoute, isActingAsMember, userCan } from 'helpers/panelPermissions';

/**
 * O que a pessoa pode fazer no painel do produtor. Produtor, admin e
 * estabelecimento podem tudo; quem entrou por uma equipe só o que ela liberou.
 */
export default function usePanelPermissions() {
    const { user } = useUser();

    return {
        isActing: isActingAsMember(user),
        actingAs: user?.acting_as || null,
        can: (...permissions) => userCan(user, ...permissions),
        canOpen: (route) => canOpenRoute(user, route),
    };
}
